import(/* webpackMode: "eager", webpackExports: ["VacancyFilter"] */ "/app/src/app/(frontend)/[locale]/vacancies/VacancyFilter.tsx");
